import { App } from 'vue'

import ButtonDetails from './ButtonDetails.vue'
import ButtonToggle from './ButtonToggle.vue'
import FavouriteCatalog from './FavouriteCatalog.vue'

const register = (app: App<Element>): void => {
  app
    .component('favourite-button-details', ButtonDetails)
    .component('favourite-button-toggle', ButtonToggle)
    .component('favourite-catalog', FavouriteCatalog)
}

export default {
  register,
}
